import apiClient from './client';

export interface AllSettings {
  cache_ttl_ms: number;
  sync_interval_hours: number;
  sync_enabled: boolean;
  performers_min_spend: number;
  [key: string]: unknown;
}

export const PERFORMERS_MIN_SPEND_KEY = 'performers_min_spend';
export const PERFORMERS_MIN_SPEND_DEFAULT = 4000;

export interface CacheStatus {
  size: number;
  ttlMs: number;
  entries: Array<{
    key: string;
    expiresAt: string;
    createdAt: string;
  }>;
}

export async function getAllSettings(): Promise<AllSettings> {
  const response = await apiClient.get('/settings');
  return response.data.settings;
}

export async function getSetting<T>(key: string): Promise<T> {
  const response = await apiClient.get(`/settings/${key}`);
  return response.data.value;
}

export async function updateSetting<T>(key: string, value: T): Promise<void> {
  await apiClient.put(`/settings/${key}`, { value });
}

export async function getCacheStatus(): Promise<CacheStatus> {
  const response = await apiClient.get('/settings/cache/status');
  return response.data.cache;
}

export async function clearCache(): Promise<{ success: boolean; message: string }> {
  const response = await apiClient.post('/settings/cache/clear');
  return response.data;
}

export async function clearExpiredCache(): Promise<{ success: boolean; message: string }> {
  const response = await apiClient.post('/settings/cache/clear-expired');
  return response.data;
}

export interface CacheWarmStatus {
  lastWarmedAt: string | null;
  entryCount: number;
}

export async function getCacheWarmStatus(): Promise<CacheWarmStatus> {
  const response = await apiClient.get('/settings/cache/warm-status');
  return response.data;
}

export async function refreshCache(): Promise<{ success: boolean; message: string }> {
  const response = await apiClient.post('/settings/cache/refresh');
  return response.data;
}
